import { UpdatePartyComponent } from './layout/management/party/update-party/update-party.component';
import { NewPartyComponent } from './layout/management/party/new-party/new-party.component';
import { PartyComponent } from './layout/management/party/party.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { ManagementComponent } from './layout/management/management.component';
import { SearchTemplatesComponent } from './layout/management/templates/search-templates/search-templates.component';
import { NewTemplateComponent } from './layout/management/templates/new-template/new-template.component';
import { CoverageComponent } from './layout/management/coverage/coverage.component';
import { CoverageLoadComponent } from './layout/management/coverage/coverage-load/coverage-load.component';
import { CoverageDownloadComponent } from './layout/management/coverage/coverage-download/coverage-download.component';
import { CoveragePrioritiesComponent } from './layout/management/coverage/coverage-priorities/coverage-priorities.component';
import { AuthGuard } from './services/auth/KeycloakAuthGuard';
import { Role } from './utils/Role';
import { AuthRedirectionComponent } from './layout/auth-redirection/auth-redirection.component';
import { SearchProductsComponent } from './layout/products/search-products/search-products.component';
import { SearchFtthResourcesComponent } from './layout/resources/ftth-resources/search-ftth-resources/search-ftth-resources.component';
import { ProductDetailComponent } from './layout/products/search-products/product-detail/product-detail.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { SearchOrdersComponent } from './layout/orders/search-orders/search-orders.component';
import { FtthResourceDetailComponent } from './layout/resources/ftth-resources/ftth-resource-detail/ftth-resource-detail.component';
import { ResourcesComponent } from './layout/resources/resources.component';
import { SearchTasksComponent } from './layout/tasks/container-tasks/search-tasks.component';
import { SpecificTaskComponent } from './layout/tasks/specific-task/specific-task.component';
import { SpecificOrderComponent } from './layout/orders/specific-order/specific-order.component';
import { CatalogSearchComponent } from './layout/management/catalog/catalog-search/catalog-search.component';
import { CatalogDetailComponent } from './layout/management/catalog/catalog-search/catalog-detail/catalog-detail.component';
import { FtthResourcesLoadComponent } from './layout/management/ftth-resources-load/ftth-resources-load.component';
import { NewProductSuccessComponent } from './layout/products/new-product-success/new-product-success.component';
import { NewProductComponent } from './layout/products/new-product/new-product.component';
import { CatalogLoadComponent } from './layout/management/catalog/catalog-load/catalog-load.component';
import { CatalogComponent } from './layout/management/catalog/catalog.component';
import { CatalogListComponent } from './layout/catalog/catalog-list/catalog-list.component';
import { SearchServiceTemplatesComponent } from './layout/management/service-templates/search-service-templates/search-service-templates.component';
import { NewServiceTemplateComponent } from './layout/management/service-templates/new-service-template/new-service-template.component';
import { TaskManagementComponent } from './layout/management/taskmanagement/taskmanagement.component';
import { AddQueueComponent } from './layout/management/taskmanagement/add-queue/add-queue.component';
import { MasterDataComponent } from './layout/management/master-data/master-data.component';
import { NewMasterDataComponent } from './layout/management/master-data/new-master-data/new-master-data.component';
import { PortOutComponent } from './layout/management/port-out/port-out.component';
import { PortOutDetailComponent } from './layout/management/port-out/port-out-detail/port-out-detail.component';

const routes: Routes = [
  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: '403',
    component: ForbiddenComponent,
  },
  {
    path: 'provision/authRedirection',
    component: AuthRedirectionComponent,
  },
  {
    path: 'provision/orders/search',
    component: SearchOrdersComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Orders] }
  },
  {
    path: 'provision/orders/detail',
    component: SpecificOrderComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Orders] }
  },
  {
    path: 'provision/tasks/search',
    component: SearchTasksComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Tasks] }
  },
  {
    path: 'provision/tasks/detail',
    component: SpecificTaskComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Tasks] }
  },
  {
    path: 'provision/products/search',
    component: SearchProductsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Products] }
  },
  {
    path: 'provision/products/new',
    component: NewProductComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Products] }
  },
  {
    path: 'provision/products/success',
    component: NewProductSuccessComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Products] }
  },
  {
    path: 'provision/products/detail',
    component: ProductDetailComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Products] }
  },
  {
    path: 'provision/catalog',
    component: CatalogListComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Catalog] }
  },
  {
    path: 'provision/management',
    component: ManagementComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.CatalogManagement, Role.Coverage, Role.Templates, Role.FtthLoad, Role.TaskManagement, Role.MasterData, Role.PortOut] }
  },
  {
    path: 'provision/management/templates/search',
    component: SearchTemplatesComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Templates] }
  },
  {
    path: 'provision/management/templates/new',
    component: NewTemplateComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Templates] }
  },
  {
    path: 'provision/management/serviceTemplates/search',
    component: SearchServiceTemplatesComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Templates] }
  },
  {
    path: 'provision/management/serviceTemplates/new',
    component: NewServiceTemplateComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Templates] }
  },
  {
    path: 'provision/management/ftthResourcesLoad',
    component: FtthResourcesLoadComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.FtthLoad] }
  },
  {
    path: 'provision/resources',
    component: ResourcesComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Resources] }
  },
  {
    path: 'provision/resources/ftth/search',
    component: SearchFtthResourcesComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Resources] }
  },
  {
    path: 'provision/resources/ftth/detail/:id',
    component: FtthResourceDetailComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Resources] }
  },
  {
    path: 'provision/management/coverage',
    component: CoverageComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Coverage] }
  },
  {
    path: 'provision/management/coverage/load',
    component: CoverageLoadComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Coverage] }
  },
  {
    path: 'provision/management/coverage/priorities',
    component: CoveragePrioritiesComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Coverage] }
  },
  {
    path: 'provision/management/coverage/download',
    component: CoverageDownloadComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Coverage] }
  },
  {
    path: 'provision/management/catalog',
    component: CatalogComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.CatalogManagement] }
  },
  {
    path: 'provision/management/catalog/load',
    component: CatalogLoadComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.CatalogManagement] }
  },
  {
    path: 'provision/management/catalog/search',
    component: CatalogSearchComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.CatalogManagement] }
  },
  {
    path: 'provision/management/catalog/detail',
    component: CatalogDetailComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.CatalogManagement] }
  },
  {
    path: 'provision/management/party',
    component: PartyComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.CatalogManagement] }
  },
  {
    path: 'provision/management/party/new-party',
    component: NewPartyComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.CatalogManagement] }
  },
  {
    path: 'provision/management/taskmanagement',
    component: TaskManagementComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.TaskManagement] }
  },
  {
    path: 'provision/management/taskmanagement/add-queue',
    component: AddQueueComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.TaskManagement] }
  },
  {
    path: 'provision/management/master-data',
    component: MasterDataComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.MasterData] }
  },
  {
    path: 'provision/management/master-data/add-spec',
    component: NewMasterDataComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.MasterData] }
  },
  {
    path: 'provision/management/port-out',
    component: PortOutComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.PortOut] }
  },
  {
    path: 'provision/management/port-out/detail',
    component: PortOutDetailComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.PortOut] }
  },
  { path: '', redirectTo: '/provision/authRedirection', pathMatch: 'full' },
  { path: '**', redirectTo: '/404' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
